import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCustomFieldStagesets_stagesets as Stageset,
    GetCustomFieldStagesets as GetCustomFieldStagesetsQuery,
} from 'nutshell-graphql-types';

import GET_CUSTOM_FIELD_STAGESETS from '../queries/get-custom-field-stagesets.graphql';

export const useGetCustomFieldStagesets = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    stagesets: Stageset[];
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetCustomFieldStagesetsQuery,
        Record<any, any>
    >(GET_CUSTOM_FIELD_STAGESETS, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        stagesets: data && data.stagesets ? data.stagesets : [],
        refetch,
    };
};
